export default __webpack_public_path__ + "static/media/tenstbetterptable.f5ec733c.webp";